import moment from 'moment'

import { extend } from 'vee-validate'

import {
  email,
  excluded,
  max,
  max_value as maxValue,
  min,
  min_value as minValue,
  regex,
  required
} from 'vee-validate/dist/rules'

import { CurrencyInputOptions, parseCurrency } from 'vue-currency-input'

import api from '@/apiClient'

extend('date', {
  params: ['min', 'max'],
  validate (value: string, params) {
    const { min, max } = params as Partial<Record<string, string | null>>

    const date = moment(value)

    if (date.isValid()) {
      if (min && date.isBefore(min)) {
        return 'Não deve ser menor que ' + moment(min).format('L')
      }

      if (max && date.isAfter(max)) {
        return 'Não deve ser maior que ' + moment(max).format('L')
      }

      return true
    } else {
      return 'Não é uma data válida'
    }
  }
})

extend('email', {
  ...email,
  message: 'Não é um email válido'
})

extend('excluded', {
  ...excluded,
  message: 'Valor inválido'
})

extend('max', {
  ...max,
  message: '{_field_} deve ter no máximo {length} caracteres'
})

extend('maxPrice', {
  params: [
    {
      name: 'options'
    }
  ],
  validate (value, params) {
    const options = (params as Record<string, CurrencyInputOptions>).options

    if (options.valueRange === undefined) {
      throw new Error('Missing valueRange')
    }

    return maxValue.validate(parseCurrency(value, options), { max: options.valueRange.max })
  },
  message: '{_field_} está acima do limite'
})

extend('maxValue', {
  ...maxValue,
  message: '{_field_} deve ser no máximo {max}'
})

extend('min', {
  ...min,
  message: '{_field_} deve ter pelo menos {length} caracteres'
})

extend('minPrice', {
  params: [
    {
      name: 'options'
    }
  ],
  validate (value, params) {
    const options = (params as Record<string, CurrencyInputOptions>).options

    if (options.valueRange === undefined) {
      throw new Error('Missing valueRange')
    }

    return minValue.validate(parseCurrency(value, options), { min: options.valueRange.min })
  },
  message: '{_field_} está abaixo do limite'
})

extend('minValue', {
  ...minValue,
  message: '{_field_} deve ser no mínimo {min}'
})

extend('regex', {
  ...regex,
  message: 'Valor inválido'
})

extend('required', {
  ...required,
  message: 'Esse campo é obrigatório'
})

extend('verifySlug', {
  validate (value: string) {
    return value
      ? api.menu.deliverySettings.verifySlug(value)
      : false
  },
  message: 'Já está sendo usado'
})
